
import { motion } from 'framer-motion';

const assets = [
  {
    category: 'DIGITAL BILLBOARD',
    name: 'ストリップ大型LED',
    spec: '1,200㎡ / 4K解像度',
    image: 'https://public.readdy.ai/ai/img_res/016d57eda72c8e7e1f4030195135c853.jpg'
  },
  {
    category: 'HIGHWAY MEDIA',
    name: 'I-15ハイウェイ',
    spec: '日間50万インプレッション',
    image: 'https://readdy.ai/api/search-image?query=Large%20highway%20billboard%20along%20Interstate%2015%20near%20Las%20Vegas%2C%20illuminated%20at%20dusk%2C%20cars%20passing%20by%20with%20motion%20blur%2C%20professional%20advertising%20photography%2C%20dramatic%20sky&width=600&height=800&seq=asset002&orientation=portrait'
  },
  {
    category: 'AIRPORT CORRIDOR',
    name: '空港アクセス',
    spec: '年間4,800万旅客',
    image: 'https://readdy.ai/api/search-image?query=Premium%20digital%20advertising%20display%20near%20Las%20Vegas%20airport%20corridor%2C%20modern%20infrastructure%2C%20travelers%20passing%20by%2C%20professional%20commercial%20photography%2C%20clean%20modern%20aesthetic&width=600&height=800&seq=asset003&orientation=portrait'
  },
  {
    category: 'DOWNTOWN NETWORK',
    name: 'フリーモント地区',
    spec: '24時間365日稼働',
    image: 'https://readdy.ai/api/search-image?query=Fremont%20Street%20Experience%20Las%20Vegas%20with%20massive%20LED%20canopy%20and%20digital%20billboards%2C%20vibrant%20nightlife%2C%20neon%20lights%2C%20professional%20urban%20photography%2C%20dramatic%20composition&width=600&height=800&seq=asset004&orientation=portrait'
  },
  {
    category: 'CONVENTION CENTER',
    name: 'LVCC周辺',
    spec: '年間600万来場者',
    image: 'https://readdy.ai/api/search-image?query=Las%20Vegas%20Convention%20Center%20area%20with%20large%20digital%20advertising%20displays%2C%20modern%20architecture%2C%20business%20travelers%2C%20professional%20commercial%20photography%2C%20clean%20composition&width=600&height=800&seq=asset005&orientation=portrait'
  },
  {
    category: 'STADIUM DISTRICT',
    name: 'アレジアント周辺',
    spec: '大型イベント連動',
    image: 'https://readdy.ai/api/search-image?query=Allegiant%20Stadium%20Las%20Vegas%20area%20with%20premium%20outdoor%20advertising%20billboards%2C%20modern%20sports%20venue%2C%20evening%20atmosphere%2C%20professional%20architectural%20photography&width=600&height=800&seq=asset006&orientation=portrait'
  }
];

const stats = [
  { value: '127', label: '総資産数' },
  { value: '8.2M', label: '月間リーチ' },
  { value: '94%', label: '市場カバー率' }
];

export default function AssetsSection() {
  return (
    <section id="assets" className="relative bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <span className="text-black text-xs tracking-[0.2em] uppercase font-semibold">
                Our Dominance
              </span>
              <h2 className="text-4xl md:text-5xl font-black text-black mt-4 leading-tight">
                所有・運営する
                <br />
                都市メディア<span className="text-amber-500">資産</span>
              </h2>
              <p className="text-gray-600 mt-6 leading-relaxed">
                ラスベガス主要エリアにおけるビルボード広告の視認性を独占。
                ストリップからハイウェイ、空港周辺まで、
                都市の動線を完全にカバーする屋外広告メディア資産ネットワーク。
              </p>

              <div className="grid grid-cols-3 gap-6 mt-10">
                {stats.map((stat, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <div className="text-4xl font-black text-black">{stat.value}</div>
                    <div className="text-xs text-gray-500 mt-1">{stat.label}</div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {assets.map((asset, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
                    <img 
                      src={asset.image}
                      alt={`ラスベガス ${asset.name} ビルボード広告 屋外広告メディア資産`}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-white/10 backdrop-blur-sm text-white text-[10px] tracking-wider rounded-full">
                        {asset.category}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-white text-xl font-bold">{asset.name}</h3>
                      <p className="text-white/60 text-sm mt-1">{asset.spec}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
